export default "__VITE_ASSET__uC9XA4_y__"